<template>
  <div class="image-grid-component">
    <div class="image-container">
      <!-- Square image with overlay -->
      <div class="image-wrapper">
        <image-component
          :imageUrl="imageUrl"
          :imageLabel="imageLabel"
        ></image-component>

        <div class="progress-overlay" v-if="uploadProgress.visible">
          <div>
            <app-progress-bar
              :progress="uploadProgress.progress"
            ></app-progress-bar>
            <p
              style="text-align: center;font-weight: bold;text-transform: uppercase;font-size: 12px;margin-top: 8px;color: white;"
            >
              Uploading new image...
            </p>
          </div>
        </div>
      </div>

      <!-- File upload section -->
      <change-image-section
        :id="id"
        @on-file-upload="handleFileUpload"
        @on-url-update="handleUrlUpdate"
      ></change-image-section>
      <div>
        <p class="validation-error-message" v-if="error">{{ error }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import AppProgressBar from '../../AppComponents/Loaders/AppProgressBar.vue';
import ChangeImageSection from './ChangeImageSection.vue';
import ImageComponent from './ImageComponent.vue';
import ProgressState from '../../../mixins/ProgressState';
import FileServices from '../../../services/files';

export default {
  name: 'ImageGrid',
  props: ['imageUrl', 'imageKey', 'imageLabel', 'id', 'error'],
  mixins: [ProgressState],
  components: {
    AppProgressBar,
    ChangeImageSection,
    ImageComponent,
  },
  created() {
    this.registerLoader('imageUpload');
  },
  computed: {
    uploadProgress() {
      return this.progress['imageUpload'];
    },
  },
  methods: {
    handleFileUpload(data) {
      this.startProgress('imageUpload');

      const formData = new FormData();
      formData.append('image', data.file);
      formData.append('subType', 'property-image-update');

      FileServices.uploadFile(formData).then((response) => {
        this.endProgress('imageUpload');

        const cdnUrl = process.env.VUE_APP_CDN_URL;
        this.emitOnImageUpdated(cdnUrl + response.location);

        setTimeout(() => {
          this.closeProgress('imageUpload');
        }, 500);
      });
    },
    handleUrlUpdate(data) {
      this.startProgress('imageUpload');
      this.emitOnImageUpdated(data.url);

      setTimeout(() => {
        this.endProgress('imageUpload');
        setTimeout(() => {
          this.closeProgress('imageUpload');
        }, 1000);
      }, 500);
    },
    emitOnImageUpdated(imageUrl) {
      this.$emit('on-image-updated', {
        imageUrl: imageUrl,
        imageKey: this.imageKey,
      });
    },
  },
};
</script>

<style scoped>
.image-grid-component {
  background-color: white;
  border-radius: 8px;
  display: inline-block;
}

.image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image-wrapper {
  position: relative;
  margin-bottom: 12px;
}

.progress-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 8px;
}

.upload-label:hover {
  background-color: #0056b3;
}

.validation-error-message {
  font-size: 14px;
  color: red;
  max-width: 200px;
  text-align: center;
}
</style>
